import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import * as API from "../../../../../../app/public_api";
import { CreationFilterState } from "../../../../../../utils-creation/types";
import * as T from "../../../../../../utils/types";

const rFcltDeptStat = createAsyncThunk(
  "creationFilter/rFcltDeptStat",
  async (
    data: {
      searchInput: T.searchInput;
      keywordType: T.keywordType;
      year: number;
    },
    thunkAPI
  ) => {
    return await API.rFcltDeptStat_Creation(
      data.searchInput,
      data.keywordType,
      data.year
    );
  }
);

export const creationFilterThunks = { rFcltDeptStat };

export const initialState: CreationFilterState = {
  fcltDeptStat: { total: 0, faculties: [], departments: [] },
  status: "idle",
  errorMsg: null,
  currentRequestId: null,
};

// pubSearchPageS: pubSearchPageSlice
const creationFilterS = createSlice({
  name: "creationSearchPage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(rFcltDeptStat.pending, (state, action) => {
      state.status = "loading";
      state.currentRequestId = action.meta.requestId;
    });
    builder.addCase(rFcltDeptStat.fulfilled, (state, action) => {
      // below line makes sure the response comes from the most recent request
      if (action.meta.requestId === state.currentRequestId) {
        state.status = "succeeded";
        state.fcltDeptStat = action.payload;
      }
    });
    builder.addCase(rFcltDeptStat.rejected, (state, action) => {
      // below line makes sure the response comes from the most recent request
      if (action.meta.requestId === state.currentRequestId) {
        state.status = "failed";
        state.errorMsg = action.error.message;
      }
    });
  },
});

export default creationFilterS;
